export default {"src":"/_next/static/media/twitch-logo.9bcccf32.svg","height":2800,"width":2700};